<script>
import { mapState } from 'vuex'

import Header from '../../../components/header'
import Icon from '../../../components/icon'
import CONSTANT from '../../../constant/preorder'

export default {
  data() {
    return {
      temValue: '',
      mobileValue: this.$store.state.preorder.mobile || '',
    }
  },
  components: {
    Icon,
    'my-header': Header
  },
  computed: {
    ...mapState({
      stateMobile: state => state.preorder.mobile || ''
    }),
  },
  watch: {
    stateMobile(nv, ov) {
      if (nv && nv != ov) {
        this.mobileValue = nv
      }
    }
  },
  methods: {
    saveMobile() {
      return this.$emit('saveMobile', this.mobileValue)
    },
    clear() {
      this.mobileValue = ''
    }
  },
  mounted() {
  }
}
</script>
<template>
  <div class="schedule-mobile-input">
    <my-header>
      <div slot="title">输入手机号码</div>
      <div class="save" slot="right" @click="saveMobile">保存</div>
    </my-header>
    <div class="mobile-text">
      <input type="tel" placeholder="请输入手机号" v-model="mobileValue" >
      <div class="delete" @click="clear">
        <Icon :size="12">tubiaoguifan2</Icon>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';

.schedule-mobile-input {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .save {
    font-size: 15px;
    color: @steelGrey
  }
  .mobile-text {
    padding-top: 55px;
    height: 105px;
    width: 100%;
    position: relative;
    color: @lightSliver;
    input {
      width: calc(~'100vw - 30px');
      display: inline-block;
      padding: 14px 15px;
      border: none;
    }
    .delete {
      position: absolute;
      right: 0;
      bottom: 16px;
      line-height: 21px;
      margin-right: 20px;
      height: 20px;
      width: 20px;
      border-radius: 10px;
      background-color: @lightSliver;
      text-align: center;
      color: #fff;
    }
  }
}
</style>



